import {isValidElement} from 'react'
import {Layout} from '../../../layout'
import {Title} from '../../../text'

const SelectHeaderLayout = ({children, ...rest}) => (
	<Layout className="select-header" direction="vertical" vertical="center" width="full" background="white" {...rest}>
		{children}
	</Layout>
)

export const SelectHeader = ({title, countSuffix}) => {
	if (!title) return null

	const isElement = isValidElement(title)

	if (isElement) return <SelectHeaderLayout>{title}</SelectHeaderLayout>

	const props = _.isString(title) ? {t: title} : title

	return (
		<SelectHeaderLayout padding="8 16" height={48} borderBottom>
			<Title countSuffix={countSuffix} {...props} />
		</SelectHeaderLayout>
	)
}
